





























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

import { WalletModule } from '@/store/modules/wallet'
import { isIOS } from '@/common/utils'
import { unitFormat } from '@/common/utils'
@Component
export default class extends Vue {
  @Prop()
  item!: ChargeListItem
  @Prop()
  active!: boolean
  @Prop({
    type: String,
    default: '元'
  })
  orgUnit!: string
  @Prop({
    type: String,
    default: '金币'
  })
  targetUnit!: string
  unitFormat = unitFormat
  handleClick() {
    WalletModule.setCustomInputStatus(true)
  }
  isIOS = isIOS
}
